import uikitMagics from "./main.magics.js";
import uikitDirectives from "./main.directives.js";

export default function uikit(Alpine) {
    uikitMagics(Alpine);
    uikitDirectives(Alpine);
}